import React from "react";
import "../styles/Brands.css";
import { useTranslation } from "react-i18next";
import {
  OUR_BRANDS_LABEL,
  BRANDS_HEADING,
  BRANDS_HEADING_EMPHASIS,
  BRANDS_SUBTITLE,
  BRAND_NUKRISHI_KICKER,
  BRAND_NUKRISHI_NAME,
  BRAND_NUKRISHI_DESC,
  BRAND_NUKRISHI_TAG_1,
  BRAND_NUKRISHI_TAG_2,
  BRAND_NUKRISHI_TAG_3,
  BRAND_AMERICANBULLS_KICKER,
  BRAND_AMERICANBULLS_NAME,
  BRAND_AMERICANBULLS_DESC,
  BRAND_AMERICANBULLS_TAG_1,
  BRAND_AMERICANBULLS_TAG_2,
  BRAND_VISIT_CTA,
} from "../data/i18n/brands";
import { NUKRISHI_URL, AMERICANBULLS_URL } from "../data/brandUrls";

const Brands = () => {
  const { t } = useTranslation();
  return (
    <section className="brands" id="brands">
      <div className="brands-head">
        <div className="brands-label">{t(OUR_BRANDS_LABEL)}</div>
        <h2 className="brands-heading">
          {t(BRANDS_HEADING)} <em>{t(BRANDS_HEADING_EMPHASIS)}</em>
        </h2>
        <p className="brands-subtitle">{t(BRANDS_SUBTITLE)}</p>
      </div>

      <div className="brand-grid">
        <div className="brand-panel nukrishi">
          <span className="brand-kicker">
            <span className="brand-kicker-dot" />
            {t(BRAND_NUKRISHI_KICKER)}
          </span>
          <h3 className="brand-name">{t(BRAND_NUKRISHI_NAME)}</h3>
          <p className="brand-desc">{t(BRAND_NUKRISHI_DESC)}</p>
          <div className="brand-tags">
            <span className="brand-tag">{t(BRAND_NUKRISHI_TAG_1)}</span>
            <span className="brand-tag">{t(BRAND_NUKRISHI_TAG_2)}</span>
            <span className="brand-tag">{t(BRAND_NUKRISHI_TAG_3)}</span>
          </div>
          <a
            className="brand-visit-btn"
            href={NUKRISHI_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(BRAND_VISIT_CTA)}
          </a>
        </div>

        <div className="brand-panel americanbulls">
          <span className="brand-kicker">
            <span className="brand-kicker-dot" />
            {t(BRAND_AMERICANBULLS_KICKER)}
          </span>
          <h3 className="brand-name">{t(BRAND_AMERICANBULLS_NAME)}</h3>
          <p className="brand-desc">{t(BRAND_AMERICANBULLS_DESC)}</p>
          <div className="brand-tags">
            <span className="brand-tag">{t(BRAND_AMERICANBULLS_TAG_1)}</span>
            <span className="brand-tag">{t(BRAND_AMERICANBULLS_TAG_2)}</span>
          </div>
          <a
            className="brand-visit-btn"
            href={AMERICANBULLS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(BRAND_VISIT_CTA)}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Brands;
